import { useState, useEffect } from 'react';

// Ancho fijo reservado para "Activado" / "Desactivado": evita que el switch
// cambie de posición según la longitud del texto.
const TEXT_WIDTH = 88;

export default function Switch({ label, defaultOn = false, onChange, showLabel = true, disabled = false, forcedOff = false }) {
  const [on, setOn] = useState(defaultOn && !forcedOff);

  useEffect(() => {
    setOn(defaultOn && !forcedOff);
  }, [defaultOn, forcedOff]);

  const toggle = (e) => {
    if (disabled || forcedOff) return;
    e.stopPropagation();
    const next = !on;
    setOn(next);
    onChange?.(next);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={toggle}
      className={`flex items-center gap-3 bg-transparent border-none p-0 touch-manipulation select-none ${
        disabled || forcedOff ? 'cursor-not-allowed' : 'cursor-pointer'
      }`}
      style={{ opacity: disabled || forcedOff ? 0.45 : 1 }}
    >
      {showLabel && (
        <span
          className="font-medium"
          style={{
            fontSize: '14px',
            fontFamily: '"Public Sans", sans-serif',
            color: on ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.45)',
            width: `${TEXT_WIDTH}px`,
            flexShrink: 0,
            textAlign: 'left',
            transition: 'color 0.2s ease',
          }}
        >
          {on ? 'Activado' : 'Desactivado'}
        </span>
      )}
      <div
        className="relative flex items-center"
        style={{
          width: '48px',
          height: '28px',
          borderRadius: '9999px',
          backgroundColor: on ? '#0a84ff' : 'rgba(255, 255, 255, 0.12)',
          flexShrink: 0,
          transition: 'background-color 0.2s ease',
        }}
      >
        <div
          className="absolute bg-white rounded-full"
          style={{
            width: '22px',
            height: '22px',
            top: '3px',
            left: on ? '23px' : '3px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.35)',
            transition: 'left 0.2s ease',
          }}
        />
      </div>
    </button>
  );
}
